import "core-js/modules/es6.reflect.construct.js";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["picker"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import DatePicker from './DatePicker';
import MonthPicker from './MonthPicker';
import RangePicker from './RangePicker';
import WeekPicker from './WeekPicker';
import YearPicker from './YearPicker';
import { Warning } from "../../wui-core/src"; // import {get} from "lodash-es"
// import getLang from "./lang-utils"
// import zhCN from "./locale/zh_CN";

var isShouldUpdate = Warning.isShouldUpdate; // 临时适配antd的picker属性

var DatePickerAdapter = /*#__PURE__*/function (_Component) {
  _inherits(DatePickerAdapter, _Component);

  var _super = _createSuper(DatePickerAdapter);

  function DatePickerAdapter() {
    _classCallCheck(this, DatePickerAdapter);

    return _super.apply(this, arguments);
  }

  _createClass(DatePickerAdapter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          picker = _this$props.picker,
          other = _objectWithoutProperties(_this$props, _excluded); // const lang = get(locale, 'locale', '')
      // const currentLang = getLang(lang, locale)


      isShouldUpdate("DatePicker", this.props);

      switch (picker) {
        case "month":
          return /*#__PURE__*/React.createElement(MonthPicker
          /*locale ={currentLang}*/
          , other);

        case "week":
          return /*#__PURE__*/React.createElement(WeekPicker
          /*locale ={currentLang}*/
          , other);

        case "year":
          return /*#__PURE__*/React.createElement(YearPicker
          /*locale ={currentLang}*/
          , other);

        default:
          return /*#__PURE__*/React.createElement(DatePicker
          /*locale ={currentLang}*/
          , other);
      }
    }
  }]);

  return DatePickerAdapter;
}(Component);

DatePickerAdapter.WeekPicker = WeekPicker;
DatePickerAdapter.MonthPicker = MonthPicker;
DatePickerAdapter.YearPicker = YearPicker;
DatePickerAdapter.RangePicker = RangePicker; // DatePickerAdapter.defaultProps = DatePicker.defaultProps;

export default DatePickerAdapter;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/index.js